module.exports = __webpack_public_path__ + "img/device-9.3c0a6632.png";